import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import Swal from 'sweetalert2';
import { RestaurantDetails } from '../../restaurants/models/List.Restaurant';
import { RestaurantService } from '../../restaurants/services/Restaurant.service';
import { HoursFormComponent } from './hours-form/hours-form.component';
import { ListData } from './models/List.Hours';
import { HourService } from './services/Hours.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-hours-config',
  templateUrl: './hours-config.component.html'
})
export class HoursConfigComponent extends DirtyComponent implements OnInit {

  dataLoading = true;
  btnLoading = false;

  // Restaurant ID
  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];
  restaurantData!: any;

  workingSlots: any[] = [];
  workingSlotsCopy: any[] = [];

  workingDays: any = []
  workingDaysCopy: any[] = []

  recordsData!: ListData | null;

  selectedHours: any[] = []

  constructor(private restaurantService: RestaurantService,
    public dialog: MatDialog, private service: HourService,
    private cdr: ChangeDetectorRef,
    translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,) {
    super(translate)
  }

  ngOnInit(): void {
    this.workingSlots = []
    this.workingSlotsCopy = []
    this.workingDays = []
    this.workingDaysCopy = []
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  getAll(restId?: any) {
    this.dataLoading = true;
    this.restaurantId = restId;

    this.service.getAll(this.restaurantId).subscribe(
      (data: ListData) => {
        if (data) {
          this.recordsData = data;
          this.recordsData.workingDays.map((item) => {
            item.selectedHours = item.workingSlots.filter((item: any) => item.isActive)
            this.workingSlots = item.selectedHours
            this.workingSlotsCopy = JSON.parse(JSON.stringify(this.workingSlots));
            this.workingDaysCopy = JSON.parse(JSON.stringify(this.workingDays));
          })
          this.workingSlots = []
          this.workingSlotsCopy = []
          this.workingDays = []
          this.workingDaysCopy = []
          this.dataLoading = false;
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });
  }

  changeToggle(name: any, isActive?: boolean, record: any | null = null, selectedHours?: any) {
    if (!this.workingDays.includes(name)) {
      this.workingDays.push(name)
    }

    if (!isActive) {
      this.openHourConfigForm(record, selectedHours)
    }

  }

  override canDeactivate(): boolean {
    return this.workingSlots?.length !== this.workingSlotsCopy?.length
      || this.workingDays?.length !== this.workingDaysCopy?.length
  }

  override openConfirmDialog() {

    if (this.canDeactivate()) {
      
      return Swal.fire({
        title: this.translate.instant('swalMsg.are you sure you want to discard all the changes'),
        text: this.leaveMsg || this.translate.instant('swalMsg.It looks like youre in the middle of updating the menu but havent saved the changes yet'),
        imageUrl: './assets/images/icons/warning-ic.svg',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('swalMsg.Yes'),
        cancelButtonText: this.translate.instant('swalMsg.No'),
        width: '560'
      }).then((result) => {
        if (result.value) {
          this.workingSlotsCopy = JSON.parse(JSON.stringify(this.workingSlots));
          this.workingDaysCopy = JSON.parse(JSON.stringify(this.workingDays));
          // if (isCancelled) {
          //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
          // } else {
          //   this.dialogRef?.close();
          //   this.close.emit(true);
          // }

          this.dialogRef?.close();
          this.close.emit(true);
          this.getAll(this.restaurantId)
          return true;
        }
        else {
          return false;
        }
      });
    } else {
      // if (isCancelled) {
      //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
      // } else {
      //   this.dialogRef?.close();
      //   this.close.emit(true);
      // }
      this.dialogRef?.close();
      this.close.emit(true);
      this.getAll(this.restaurantId)
    }
    return false;
  }

  openHourConfigForm(record: any | null = null, selectedHours: any) {
    const dialogRef = this.dialog.open(HoursFormComponent, {
      width: '530px',
      data: { record, restaurantId: this.restaurantId, selectedHours: selectedHours }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.recordsData?.workingDays.map((item) => {
          if (item.dayCode == result.dayCode) {
            item = result;
            item.selectedHours = result.workingSlots.filter((item: any) => item.isActive)
            this.workingSlots.push(item.selectedHours)
          }
        });
      } else {
        this.recordsData?.workingDays.map((item) => {
          if (item.isActive && !item.selectedHours.length) {
            item.isActive = false
          }
        })
      }
    });
  }


  saveRecord() {

    let isValidSlots
    this.recordsData?.workingDays.map((item: any) => {
      delete item.selectedHours;
    })
    let workingDays = this.recordsData?.workingDays
    let data = {
      workingDays,
      restaurantId: this.restaurantId,
    };

    // Validate Slots
    isValidSlots = this.recordsData?.workingDays.find(item => item.isActive)?.workingSlots.some(slot => slot.isActive)



    this.dataLoading = true;
    this.btnLoading = true;
    this.service.saveRecord(data).subscribe(() => {
      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      Swal.fire({
        title: this.translate.instant('swalMsg.Success'),
        text: msg,
        icon: 'success',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      }).then((res) => {
        this.dataLoading = false;
        this.btnLoading = false;
        this.workingSlotsCopy = JSON.parse(JSON.stringify(this.workingSlots));
        this.workingDaysCopy = JSON.parse(JSON.stringify(this.workingDays));
        // if (this.restaurantId) {
        //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
        // } else {
        //   this.getAll(this.restaurantId)
        // }
        this.getAll(this.restaurantId)
      });
    }, error => {
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      }).then((res) => {
        this.btnLoading = false;
        this.dataLoading = false;
        this.getAll(this.restaurantId)
      });
    });
  }

  GetScreenData() {
    this.getAll(this.restaurantId);
    this.GetRestaurantShortDetails(this.restaurantId);
  }
}
